import React, { useState, useEffect } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import { Descriptions, Button } from "antd";
import { Redirect } from "react-router-dom";

function App(props) {
  const [response, setResponse] = useState();
  const [deleted, setDeleted] = useState(false);
  const deleteAction = () => {
    Axios.delete(baseUrl + "components/" + props.match.params.id)
      .then((response) => {
        setDeleted(true);
      })
      .catch(function (error) {});
  };
  useEffect(() => {
    Axios.get(baseUrl + "components/" + props.match.params.id)
      .then((response) => {
        setResponse(response.data);
      })
      .catch(function (error) {});
  }, []);
  if (deleted) {
    return <Redirect to="/components/list" />;
  }
  if (!response) {
    return <div>Loading</div>;
  }
  return (
    <div style={{ padding: "100px 0" }}>
      <Descriptions title="Product Info" bordered layout="vertical">
        <Descriptions.Item label="Product Name">
          <p style={{ fontSize: "20pt" }}>{response.name}</p>
        </Descriptions.Item>
        <Descriptions.Item label="Product Id" span={1}>
          {response._id}
        </Descriptions.Item>
        <Descriptions.Item label="Type" span={1}>
          {response.type}
        </Descriptions.Item>
        <Descriptions.Item label="Label">{response.label}</Descriptions.Item>
        <Descriptions.Item label="activeCode" span={1}>
          {response.activeCode}
        </Descriptions.Item>
        <Descriptions.Item label="deactiveCode" span={1}>
          {response.deactiveCode}
        </Descriptions.Item>
        <Descriptions.Item label="Speed" span={1}>
          {response.speed}
        </Descriptions.Item>
      </Descriptions>
      <div style={{ paddingTop: 50 }}>
        <Button type="danger" onClick={() => deleteAction()}>
          Delete Component
        </Button>
      </div>
    </div>
  );
}

export default App;
